
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/channel/[handle]",
      function () {
        return require("private-next-pages/channel/[handle]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/channel/[handle]"])
      });
    }
  